import { Injectable } from "@angular/core";
var RenderContext = (function () {
    function RenderContext() {
    }
    Object.defineProperty(RenderContext.prototype, "context", {
        get: function () {
            return this.context_;
        },
        enumerable: true,
        configurable: true
    });
    ;
    RenderContext.prototype.create = function (canvas) {
        this.context_ = canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
        return this.context_;
    };
    ;
    RenderContext.decorators = [
        { type: Injectable },
    ];
    RenderContext.ctorParameters = function () { return []; };
    return RenderContext;
}());
export { RenderContext };
//# sourceMappingURL=webgl-context.js.map